import React, { useCallback } from 'react';

import { useSubModal } from 'components/shared/Modal/lib/SubModalContext';

const useOpenModal = () => {
  const { openSubModal, closeSubModal } = useSubModal();

  return useCallback(
    (modalProps) => {
      const handleModalClose = () => closeSubModal();
      const submitFn = modalProps?.onSubmit;
      const isDisabled = modalProps?.disabled || modalProps?.disableSubmit;

      openSubModal({
        title: modalProps?.title,
        className: modalProps?.contentClassName,
        panelClassName: modalProps?.height ? `h-[${modalProps.height}]` : '',
        content: modalProps?.content ? <modalProps.content close={handleModalClose} /> : null,
        footer: modalProps?.footer
          ? typeof modalProps.footer === 'function'
            ? modalProps.footer({ onClose: handleModalClose })
            : modalProps.footer
          : undefined,
        actions: {
          ...(submitFn && {
            text: modalProps?.submitText || 'Submit',
            onClick: async () => {
              const result = await submitFn?.();
              if (result !== false) closeSubModal();
            },
            isDisabled: typeof isDisabled === 'function' ? !!isDisabled() : !!isDisabled
          }),
          onClose: handleModalClose
        }
      });
    },
    [openSubModal, closeSubModal]
  );
};

export default useOpenModal;
